import React, { Component } from 'react';
import Link from 'gatsby-link';
import Script from 'react-load-script';
import { HomeImageContainer } from '../static/styles/styles';
import styled from 'styled-components';
import 'normalize.css';

class IndexPage extends Component {
  handleScriptLoad() {
    if (window.netlifyIdentity) {
      window.netlifyIdentity.on('init', user => {
        if (!user) {
          window.netlifyIdentity.on('login', () => {
            document.location.href = '/admin/';
          });
        }
      });
    }
    window.netlifyIdentity.init();
  }

  render() {
    const { data } = this.props;
    const { edges } = data.allHomeJson;
    const launchscreens = edges[0].node.launchscreens;
    const homeImage =
      launchscreens[Math.floor(Math.random() * launchscreens.length)];

    return (
      <div>
        <Script
          url="https://identity.netlify.com/v1/netlify-identity-widget.js"
          onLoad={this.handleScriptLoad.bind(this)}
        />
        <HomeImageContainer src={homeImage.image} alt="home-image" />
      </div>
    );
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    allHomeJson {
      edges {
        node {
          launchscreens {
            image
          }
        }
      }
    }
  }
`;

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js